// Sim Serial Number
$.validator.addMethod("sim-serial-number", function(sim_number, element) {
	return this.optional(element) || (sim_number.length == 20 && sim_number.match(/^89441000\d{12}$/));
}, "Please specify a valid sim serial number");

// SIM2 Ref
$.validator.addMethod("sim2-ref", function(sim2_ref, element) {
	return this.optional(element) || (sim2_ref.length == 10 && sim2_ref.match(/^SIM2\d{6}$/));
}, "Please specify a valid SIM2 Ref");


$.validator.addMethod("required-when-missing", function(value, element) {
    var missingInputSelector = $(element).data('missing-input');
    var $missingInput = $(missingInputSelector);

    return $missingInput.val() ? true : Boolean(value);
}, function(params, element) {
    var elementPlaceholder = element.placeholder;
    var missingInputName = $(element).data('missing-input-name');
	
    return elementPlaceholder + " is required when " + missingInputName + " is empty";
});
